import {
  CustomViewComponent,
  CustomViewPageCategory,
  CustomViewPages,
  CustomViewTemplateIdType,
  CustomViewTypeIdType,
} from '@agilelab/plugin-wb-platform';
import preview from './preview/builder_descriptor_system_preview/builder_descriptor_system_preview.png';
import thumbnail from './preview/builder_descriptor_system_preview/builder_descriptor_system_preview_thumbnail.png';

CustomViewPages.register({
  id: 'builder_descriptor_system_preview',
  meta: {
    label: 'Descriptor System Preview',
    category: CustomViewPageCategory.BUILDER,
    typeId: {
      type: CustomViewTypeIdType.SYSTEM_TYPE,
    },
    templateId: {
      type: CustomViewTemplateIdType.SYSTEM_TYPE,
    },
    preview: {
      thumbnail: { src: thumbnail },
      items: [{ src: preview }],
    },
  },
  data: (
    <>
      <CustomViewComponent type="grid_list">
        <CustomViewComponent type="hbox">
          <CustomViewComponent type="card" title="About">
            <CustomViewComponent type="container">
              <CustomViewComponent
                type="string"
                label="Name"
                path="descriptor.name"
                colSpan="2"
              />
              <CustomViewComponent
                type="string"
                label="Version"
                path="descriptor.version"
                colSpan="2"
              />
              <CustomViewComponent
                type="string"
                label="Domain"
                path="descriptor.domain"
                colSpan="2"
              />
              <CustomViewComponent
                type="string"
                label="Environment"
                path="descriptor.environment"
                colSpan="2"
              />
              <CustomViewComponent
                type="string"
                label="Kind"
                path="descriptor.kind"
                colSpan="2"
              />
              <CustomViewComponent
                type="string"
                label="Owner"
                path="descriptor.projectOwner"
                colSpan="2"
              />
            </CustomViewComponent>
          </CustomViewComponent>
        </CustomViewComponent>
      </CustomViewComponent>
    </>
  ),
});
